export const DOCS_BASE_URL = 'https://docs.plerion.com';
